module.exports = __webpack_public_path__ + "static/img/developerMeetup.4097f121.png";